import RedirectLink from '@Components/RedirectLink';
import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUtcOffsetStore } from 'src/models/useUtcOffsetModel';
import { urlMask } from 'src/utils/common';
import { formatTableTopX } from 'src/utils/table';

import { useDashboardServicesStore } from '../../../../models/useDashboardServicesModel';
import { ThreatType } from '../../../../utils/enums';
import { getServiceNamesByValues } from '../../../../utils/service';
import { generateRedirectUrlToLog } from '../../../Log/shared';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import { LogTypeEnum } from '@Types/log';

function RansomwareTop5Domains(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const timeModel = useUtcOffsetStore();
  const servicesModel = useDashboardServicesStore();
  const config = [
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '15%', grow: 0, align: 'right' },
    { width: '30%', grow: 1, align: 'left', tooltip: true },
    { width: '20%', grow: 0, align: 'left', tooltip: true },
  ];
  const header = [
    t('dashboard.chart.column.domain'),
    t('dashboard.chart.column.detections'),
    t('dashboard.chart.column.url'),
    t('dashboard.chart.column.lastDetected'),
  ];

  const data = formatTableTopX(
    props.data?.ransomwareTopDomain?.[props.day],
    ['key', 'total', 'aliases', 'last_detected'],
    t,
    timeModel.offset
  ).map((row) => [
    urlMask(row[0] as string),
    row[1] === 0 ? (
      0
    ) : (
      <RedirectLink
        href={`logs?${generateRedirectUrlToLog(
          [
            {
              field: 'threatType',
              values: [ThreatType.Ransomware],
              type: 'terms',
            },
            {
              field: 'suspiciousDomain',
              values: [row[0] as string],
              type: 'terms',
            },
            {
              field: 'scanSource',
              values: getServiceNamesByValues(servicesModel.enabledServices),
              type: 'terms',
            },
          ],
          props.day,
          LogTypeEnum.DETECTION
        )}`}
      >
        <Text>{row[1]}</Text>
      </RedirectLink>
    ),
    urlMask(row[2] as string),
    row[3],
  ]);

  // data.forEach((value, index, array) => {
  //   array[index][0] = urlMask(value[0] as string);
  //   array[index][2] = urlMask(value[2] as string);
  // });

  return (
    <DashboardCard
      title={t('dashboard.chart.title.ransomwareTop5Domains')}
      iconContent={t('dashboard.chart.desc.ransomwareTop5Domains')}
    >
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(RansomwareTop5Domains);
